import { render, staticRenderFns } from "./visitorRegistration.vue?vue&type=template&id=0ace956e&scoped=true&"
import script from "./visitorRegistration.vue?vue&type=script&lang=js&"
export * from "./visitorRegistration.vue?vue&type=script&lang=js&"
import style0 from "./visitorRegistration.vue?vue&type=style&index=0&id=0ace956e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace956e",
  null
  
)

export default component.exports